<form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div *ngFor="let field of configForm | keyvalue">
    <label [for]="field.key">{{ field.value.label }}</label>
    <ng-container [ngSwitch]="field.value.type">
      <input *ngSwitchDefault
             [id]="field.key"
             [formControlName]="field.key"
             [attr.type]="['ruc', 'dni', 'celular'].includes(field.key) ? 'number' : 'text'"
             [attr.maxlength]="field.key === 'ruc' ? 11 : (field.key === 'celular' ? 9 : (field.key === 'dni' ? 8 : null))"
      />
      <select *ngSwitchCase="'select'" [id]="field.key" [formControlName]="field.key" (change)="onSelectChange($event)">
        <option *ngFor="let option of field.value.options" [value]="option.value">{{ option.label }}</option>
      </select>
    </ng-container>
    <div *ngIf="form.get(field.key)?.invalid && form.get(field.key)?.touched">
      <small class="error">Este campo es obligatorio</small>
    </div>
  </div>

  <button nz-button nzType="primary" [disabled]="form.invalid" htmlType="submit">
    {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</form>
